<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
  <span fxFlex class="text__small night">
    {{ operation }}
    <strong>{{ progressCount }}</strong>
    of
    <strong>{{ totalCount }}</strong>
    conversations{{ progressCount < totalCount ? '...' : null }}
  </span>
  <mat-spinner *ngIf="progressCount < totalCount" [diameter]="16"></mat-spinner>
  <img *ngIf="progressCount === totalCount" src="/assets/images/onboarding/check.svg" alt="Completed" />
</div>
